module.exports = __webpack_public_path__ + "static/media/i10.5a14ecd6.jpg";